// extracted by mini-css-extract-plugin
export var section = "sectionHero-module--section--ced62";
export var text = "sectionHero-module--text--6c3a5";